<template>
    <div class="container-fluid">
        <table class="table table-bordered p-2">
            <thead>
                <th>Dato</th>
                <th>Valor (Dotted Decimal)</th>
                <th>Valor (Binario)</th>
            </thead>
            <tbody>
                <tr>
                    <th>Dirección de Red Inicial</th>
                    <td>{{ initialnetaddress }}</td>
                    <td class="text-monospace">{{ initialnetaddressbin }}</td>
                </tr>
                <tr>
                    <th>Máscara Inicial</th>
                    <td>{{ initialnetmask }} / {{ initialnetmaskcidr }}</td>
                    <td class="text-monospace">{{ initialnetmaskbin }}</td>
                </tr>
                <tr>
                    <th>Número de segmentos</th>
                    <td>{{ segments.length }}</td>
                    <td>N/A</td>
                </tr>
            </tbody>
        </table>
        <table class="table p-2">
            <thead class="thead-light">
                <tr>
                    <th class="text-center" colspan="2">Segmentos Necesitados</th>
                </tr>
                <tr>
                    <th>Nombre</th>
                    <th>Hosts necesitados</th>
                </tr>
            </thead>
            <tbody v-for="segment in segments" :key="segment.name">
                <tr>
                    <td>{{ segment.name }}</td>
                    <td>{{ segment.hosts }}</td>
                </tr>
            </tbody>
        </table>
        <table class="table p-2">
            <thead class="thead-light">
                <tr>
                    <th class="text-center" colspan="6">Subredes</th>
                </tr>
                <tr>
                    <th>Nombre</th>
                    <th>D. Red</th>
                    <th>Máscara</th>
                    <th>Primera IP</th>
                    <th>Última IP</th>
                    <th>Broadcast</th>
                </tr>
            </thead>
            <tbody v-for="subnet in subnets" :key="subnet.name">
                <tr>
                    <td>{{ subnet.name }}</td>
                    <td>{{ subnet.netaddress }}</td>
                    <td>{{ subnet.cidr }}</td>
                    <td>{{ subnet.firstaddress }}</td>
                    <td>{{ subnet.lastaddress }}</td>
                    <td>{{ subnet.bcastaddress }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import iputils from "../lib/iputils";

    function isValidCIDR(ipaddr, cidr) {
        if ((cidr < 8) || (cidr > 30)) {
            return false;
        }
        var ipclass = iputils.getClassFromIP(ipaddr);
        var ipbin = iputils.stringToLong(ipaddr);
        var maskbin = iputils.stringToLong(iputils.getCIDRSubnet(ipaddr, cidr).subnetMask);
        var validMask = (ipbin & ~maskbin) == 0;
        if ( ipclass == 'A') {
            return validMask;
        }
        if (ipclass == 'B') {
            return cidr >= 16 && validMask;
        }
        if (ipclass == 'C') {
            return cidr >= 24 && validMask;
        }
        return false;
    }

    function isValidSegments(segments) {
        return (segments.length > 0);
    }

    function areValidProps(na, nc, s) {
        return iputils.isValidIP(na)
            && isValidCIDR(na, nc)
            && isValidSegments(s);
    }

    function initializeSubnets(segments) {
        return segments.map((segment) => {
            let h = parseInt(segment.hosts);
            return {
                name: segment.name,
                hosts: h,
                size: h + 2,
                block: Math.pow(2, Math.ceil(Math.log2(h + 2))),
                netaddress: '',
                cidr: Math.ceil(Math.log2(h + 2)),
                firstaddress: '',
                lastaddress: '',
                bcastaddress: ''

            }
        }).sort((a,b) => {
            return b.block - a.block;
        });
    }

export default {
    props: ["initialnetaddress", "initialnetmaskcidr", "segments"],
    computed: {
        initialnetaddressbin: function () {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.stringToBinary(this.initialnetaddress) :
                'N/A';
        },
        initialnetmask: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.getCIDRSubnet(this.initialnetaddress, this.initialnetmaskcidr).subnetMask :
                'N/A';
        },
        initialnetmaskbin: function() {
            return (areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.subnets)) ?
                iputils.stringToBinary(this.initialnetmask) :
                'N/A';
        },
        subnets: function() {
            if (!areValidProps(this.initialnetaddress, this.initialnetmaskcidr, this.segments)) {
                return [];
            }
            var retval = initializeSubnets(this.segments);
            var inal = iputils.stringToLong(this.initialnetaddress);
            var icidr = parseInt(this.initialnetmaskcidr);
            var bs = 0;
            var subnet;
            for (subnet of retval) {
                if (subnet.block != bs) {
                    icidr += 32 - icidr - subnet.cidr;
                }
                subnet.cidr = icidr;
                var sn = iputils.getCIDRSubnet(iputils.longToString(inal), icidr);
                subnet.netaddress = sn.networkAddress;
                subnet.firstaddress = sn.firstAddress;
                subnet.lastaddress = sn.lastAddress;
                subnet.bcastaddress = sn.broadcastAddress;
                inal += Math.pow(2, 32 - icidr);
            }
            return retval;
        },

    },
}
</script>